var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ds-text-button',{attrs:{"trailing-icon":"external-link","data-qa":"manage"},on:{"click":_vm.manage}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }